export const grid = "g1okcvlx";
export const seeMore = "s303ygb";
export const heading = "h18biwhf";
export const subHeading = "sr2m7vf";

require("./style.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");